import React from "react";
import {
  Logo,
  Menu,
  MenuItem,
  MenuTitle,
  SidebarSection,
  SidebarWrapper,
} from "./styles";
import logo from "../../resources/images/yael-priority-logo.png";
import { Route } from "../../routes/Route";
import { CloudUpload, People, QueryStats } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectMetadata, selectUserData } from "../../store/user/selectors";
import { canAccess, getLandingRoute, Page } from "../../utils/auth";
import { useTranslation } from "react-i18next";

// Shown only if the user's roles open the page (see PAGE_ROLES in utils/auth)
const menuItems: { id: Page; label: string; Icon: typeof CloudUpload }[] = [
  { id: Route.Upload, label: "UPLOAD_PAGE", Icon: CloudUpload },
  { id: Route.Statistics, label: "STATISTICS_PAGE", Icon: QueryStats },
  { id: Route.Clients, label: "CLIENTS_MANAGEMENT", Icon: People },
];

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useSelector(selectUserData); // re-render once roles load
  const metadata = useSelector(selectMetadata);
  const { t } = useTranslation();

  const navigateTo = (route: Route) => () => {
    navigate(`/${route}`, { replace: true });
  };

  return (
    <SidebarWrapper>
      <SidebarSection>
        <Logo src={logo} />
        <Menu>
          <MenuTitle>{t("MENU")}</MenuTitle>
          {menuItems.filter((item) => canAccess(item.id)).map((item) => (
            <MenuItem
              key={item.id}
              selected={
                location.pathname === `/${item.id}` ||
                (location.pathname === "/" && item.id === getLandingRoute())
              }
              onClick={navigateTo(item.id)}
            >
              {t(item.label)}
              <item.Icon />
            </MenuItem>
          ))}
        </Menu>
      </SidebarSection>
      <SidebarSection>
        <MenuTitle>
          {metadata?.version
            ? t("VERSION_STRING", { version: metadata.version })
            : ""}
        </MenuTitle>
      </SidebarSection>
    </SidebarWrapper>
  );
};

export default Sidebar;
